export const ChargeStationData = [
    {
      'Charge Station': 'Lulu Mall',
      'Address': 'Delta Street, Cityville',
      'Latitude': '12.971598',
      'Longitude': '77.594562',
      'Owner': 'Delta Power Solutions',
      'status': 'active'
    },
    {
      'Charge Station': 'Obrean Mall',
      'Address': 'Delta Street, Cityville',
      'Latitude': '10.013938',
      'Longitude': '76.311999',
      'Owner': 'Delta Power Solutions',
      'status': 'active'
    },
    {
      'Charge Station': 'Green Park Plaza',
      'Address': 'Alpha Avenue, Energy City',
      'Latitude': '13.022141',
      'Longitude': '80.221705',
      'Owner': 'Green Energy Corporation',
      'status': 'active'
    },
    {
      'Charge Station': 'Tech Hub Charging Hub',
      'Address': 'Beta Boulevard, Innovation Valley',
      'Latitude': '12.927608',
      'Longitude': '77.620773',
      'Owner': 'TechCharge Networks',
      'status': 'inactive'
    },
    {
      'Charge Station': 'Eco Plaza Charging Center',
      'Address': 'Gamma Grove, Sustainable City',
      'Latitude': '12.971923',
      'Longitude': '77.593762',
      'Owner': 'EcoCharge Solutions',
      'status': 'faulted'
      
    },
    {
      'Charge Station': 'Metro Mall EV Hub',
      'Address': 'Theta Terrace, Metro City',
      'Latitude': '12.988783',
      'Longitude': '77.551455',
      'Owner': 'MetroCharge Technologies',
      'status': 'inactive'
    },
    {
      'Charge Station': 'City Square Power Point',
      'Address': 'Omega Street, Cityville',
      'Latitude': '12.963031',
      'Longitude': '77.625787',
      'Owner': 'PowerCity Networks',
      'status': 'busy'
    },
    {
      'Charge Station': 'Sunset Strip Charging Station',
      'Address': 'Delta Drive, Energy City',
      'Latitude': '13.019624',
      'Longitude': '80.218905',
      'Owner': 'Sunset Power Solutions',
      'status': 'active'
    },
    {
      'Charge Station': 'Urban Oasis Charging Hub',
      'Address': 'Sigma Street, Innovation Valley',
      'Latitude': '12.925909',
      'Longitude': '77.634625',
      'Owner': 'UrbanCharge Networks',
      'status': 'faulted'
    },
    {
      'Charge Station': 'GreenTech Plaza',
      'Address': 'Beta Boulevard, Sustainable City',
      'Latitude': '12.970568',
      'Longitude': '77.596256',
      'Owner': 'GreenTech Energy Solutions',
      'status': 'busy'
    },
    {
      'Charge Station': 'InnoPark EV Center',
      'Address': 'Theta Terrace, Metro City',
      'Latitude': '12.987953',
      'Longitude': '77.549681',
      'Owner': 'InnoCharge Technologies',
      'status': 'active'
    }
  ];

  export const vendorDropdownData = [
    {
      label:'FOCO',
      value:'FOCO'
    },
    {
      label:'COCO',
      value:'COCO'
    }
  ]

  export const categoryDropdownData = [
    {
      label:'On The GO',
      value:'On The GO'
    },
    {
      label:'Hub',
      value:'Hub'
    },
    {
      label:'Home Charging',
      value:'Home Charging'
    },
    {
      label:'Captive',
      value:'Captive'
    },
    {
      label:'Bus charging',
      value:'Bus charging'
    }
  ]
  